import i18n from "@/i18n";
import { FORMATS } from "@/utils/Const";

export function getFormat(format) {
	const formatText = format.replace("application/", "");
	const translationKey = `formats.${formatText}`;
	return i18n.te(translationKey) ? i18n.t(translationKey) : formatText;
}

export function getFormatMimeType(format) {
	if (!format) return null;
	return format?.mimeType || format?._id || format;
}

export function isPrintFormat(format) {
	const formatMimeType = getFormatMimeType(format);
	if (!formatMimeType) return false;
	if (formatMimeType === FORMATS.print) return true;
	if (typeof formatMimeType === "string") {
		return ["print", "paperback", "hardcover", "hardback"].some((type) =>
			formatMimeType.toLowerCase().includes(type),
		);
	}
	return false;
}

/**
 * Returns the Vuetify theme color name for a book format.
 * Use with v-chip color prop: <v-chip :color="getFormatColor(format)">
 *
 * Color mapping (per #1535):
 *   Print       -> 'formatPrint'   (Red #ed1c24)
 *   All digital -> 'formatDigital' (Lilac #a14572)
 *
 * @param {string|object} format - Format string or object with mimeType
 * @returns {string} Vuetify theme color name ('formatPrint' or 'formatDigital')
 */
export function getFormatColor(format) {
	const mimeType = getFormatMimeType(format);
	if (!mimeType) return "formatDigital";
	if (isPrintFormat(format)) return "formatPrint";
	return "formatDigital";
}

/**
 * Returns the Material Design icon name for a book format.
 *
 * @param {string|object} format - Format string or object with mimeType
 * @returns {string} MDI icon name
 */
export function getFormatIcon(format) {
	const mimeType = getFormatMimeType(format);
	if (isPrintFormat(format)) return "mdi-book-open-page-variant";
	if (mimeType === FORMATS.epub) return "mdi-book-outline";
	if (mimeType === FORMATS.pdf) return "mdi-file-pdf-box";
	if (mimeType === FORMATS.audio) return "mdi-headphones";
	return "mdi-file-document-outline";
}
